module.exports = __webpack_public_path__ + "img/hero.af90fe0e.jpg";